import { render, staticRenderFns } from "./ContactTile.vue?vue&type=template&id=35ff0d8c&"
import script from "./ContactTile.vue?vue&type=script&lang=js&"
export * from "./ContactTile.vue?vue&type=script&lang=js&"
import style0 from "./ContactTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContactTile.vue"
export default component.exports